import Vue from "vue";
import CaptchaVue from "@/components/Captcha/Captcha.vue";

let captchaInstance;
const CaptchaConstructor = Vue.extend(CaptchaVue);
const initCaptchaInstance = (options) => {
  captchaInstance = new CaptchaConstructor({
    ...options,
  });
};

export const renderCaptcha = (options = { withCredentials: true }) => {
  return new Promise((resolve, reject) => {
    initCaptchaInstance(options);
    captchaInstance.$mount();
    document.getElementsByTagName("body")[0].appendChild(captchaInstance.$el);
    Vue.nextTick(function () {
      captchaInstance.show = true;
    });

    captchaInstance.success = (e) => {
      destroyInstance();
      resolve({
        msg: "success",
        ...e,
      });
    };

    captchaInstance.close = () => {
      destroyInstance();
      reject(Error("已取消滑块验证"));
    };

    function destroyInstance() {
      captchaInstance.show = false;
      captchaInstance.$destroy();
      document.getElementsByTagName("body")[0].removeChild(captchaInstance.$el);
    }
  });
};
